var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemLabel = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M16.17 5c.657 0 1.272.322 1.646.862l3.853 5.569c.236.342.236.796 0 1.138l-3.853 5.569c-.374.54-.99.862-1.645.862H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Zm0 2H4v10h12.17l3.46-5zM16 11a1 1 0 1 1 0 2 1 1 0 1 1 0-2"
})));
export default SvgGemLabel;